// State
export const state = () => ({
    missions: {},
    missionsSettings: {},
    mission: {},
    rewardTnc: {},
    exchangeReward: {},
    exchangeRewardTiers: {},
    exchangeRewardTypes: {},
    allRewardHistories: [],
    coinHistories: [],
    missionLayoutType: null,
    getMissionByIdLoading: false,
    missionsLoading: {},
    missionBadge: {
        all_missions: 0,
        mission_type: {
            1: 0,
            2: 0,
            3: 0,
            4: 0,
        },
    },
    cancelToken: {},
})

// Actions
export const actions = {
    async getMissions({ commit }, params) {
        commit('setMissionLoading', { [params.mission_type]: true })
        await this.$axios
            .get('/mission-rewards/missions', { params })
            .then((data) => {
                commit('setMissions', { [params.mission_type]: data.data })
            })
            .catch((_) => {
                return false
            })
        commit('setMissionLoading', { [params.mission_type]: false })
    },
    async getMissionSettings({ commit, state }, params) {
        if (state?.cancelToken?.getMissionSettings) {
            state?.cancelToken?.getMissionSettings.cancel('')
        }
        commit('setCancelTokens', {
            getMissionSettings: this.$axios.CancelToken.source(),
        })
        await this.$axios
            .get('/mission-rewards/settings', {
                params,
                cancelToken: state.cancelToken.getMissionSettings.token,
            })
            .then((data) => {
                commit('setMissionsSettings', data.data)
                commit('setMissionLayoutType', data.data?.mission_layout)
            })
            .catch((_) => {
                return false
            })
    },
    async getMissionById({ commit }, id) {
        commit('setGetMissionByIdLoading', true)
        await this.$axios
            .get(`/mission-rewards/missions/${id}`)
            .then((data) => {
                commit('setMission', data.data)
            })
            .catch((_) => {
                return false
            })
        commit('setGetMissionByIdLoading', false)
    },
    async claimActivity({ dispatch, state }, params) {
        const response = await this.$axios
            .put(
                `/mission-rewards/missions/activities`,
                {},
                {
                    params: {
                        ...params,
                        hideToast: true,
                    },
                }
            )
            .then(async (data) => {
                // Handle success response
                if (state?.mission?.mission_type)
                    await dispatch('getMissions', {
                        mission_type: state?.mission?.mission_type,
                    })
                dispatch('getMissionBadge')
                return true
            })
            .catch((_) => {
                return false
            })
        return response
    },
    getRewardTnc({ commit }, params) {
        const response = {
            data: {
                'en-US':
                    '<html>English Terms and Conditions content here...</html>',
                'vi-VN':
                    '<html>Nội dung Điều khoản và Điều kiện bằng tiếng Việt ở đây...</html>',
            },
        }
        commit('setRewardTnc', response)
    },
    claimExchangeReward({ commit }, id) {
        return {
            reward_type: 1, // 1 = credit, 2 = item
            tier_id: 'xxx-xxx', // The ID of the tier
            quantity: 1,
        }
    },
    getExchangeRewardBalance({ commit }, id) {
        const response = {
            player_id: 'xxx-xxx', // The ID of the player
            reward_balance: 500, // The current reward balance of the player
        }
        commit('setExchangeReward', response)
    },
    getExchangeRewardTiers({ commit }, id) {
        const response = {
            data: [
                {
                    tier_id: 'tier-123', // The ID of the tier
                    sequence: 1, // The sequence in which the tier appears
                    file: 'path/to/image.jpg', // Image file path for the tier
                    name: 'Silver Tier', // The name of the tier
                },
                {
                    tier_id: 'tier-456',
                    sequence: 2,
                    file: 'path/to/image2.jpg',
                    name: 'Gold Tier',
                },
            ],
        }
        commit('setExchangeRewardTiers', response)
    },
    getExchangeRewardTypes({ commit }, params) {
        const response = {
            data: [
                {
                    id: 'reward-123', // Unique ID of the reward
                    reward_type: 1, // Reward type (1 = credit, 2 = item)
                    tier_id: 'tier-123', // Tier ID for the reward
                    file: 'path/to/image.jpg', // File path for the reward's image
                    name: 'Credit Reward', // Name of the reward
                    amount_required: 100, // Number of coins required to claim the reward
                    sequence: 1, // Sequence for the landing page
                    credit_amount: 100,
                },
                {
                    id: 'reward-456',
                    reward_type: 2,
                    tier_id: 'tier-456',
                    file: 'path/to/image2.jpg',
                    name: 'Item Reward',
                    amount_required: 200,
                    sequence: 2,
                    credit_amount: 100,
                },
            ],
        }
        commit('setExchangeRewardTypes', response)
    },
    async getMissionBadge({ commit }, params) {
        await this.$axios
            .get('/mission-rewards/mission-badges', { params })
            .then((data) => {
                commit('setMissionBadge', data.data)
            })
            .catch((_) => {})
    },
    async onClaimExtraCoin({ _ }, missionId) {
        const response = await this.$axios
            .put(
                `/mission-rewards/missions/extra-coin/${missionId}`,
                {},
                {
                    params: {
                        hideToast: true,
                    },
                }
            )
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async onClaimAllCoins({ state, dispatch }, missionId) {
        const response = await this.$axios
            .put(
                `/mission-rewards/missions/claim-all/${missionId}`,
                {},
                {
                    params: {
                        hideToast: true,
                    },
                }
            )
            .then(async (data) => {
                // Handle success response
                if (state?.mission?.mission_type)
                    await dispatch('getMissions', {
                        mission_type: state?.mission?.mission_type,
                    })
                dispatch('getMissionBadge')
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
}

// Mutations
export const mutations = {
    setMissions: (state, data) => {
        state.missions = { ...state.missions, ...data }
    },
    setMissionLoading: (state, data) => {
        state.missionsLoading = { ...state.missionsLoading, ...data }
    },
    setMissionsSettings: (state, data) => {
        state.missionsSettings = data
    },
    setMission: (state, data) => {
        state.mission = data
    },
    setRewardTnc: (state, data) => {
        state.rewardTnc = data
    },
    setExchangeReward: (state, data) => {
        state.exchangeReward = data
    },
    setExchangeRewardTiers: (state, data) => {
        state.exchangeRewardTiers = data
    },
    setExchangeRewardTypes: (state, data) => {
        state.exchangeRewardTypes = data
    },
    setAllRewardHistory: (state, data) => {
        state.allRewardHistories = data
    },
    setAllCoinsHistories: (state, data) => {
        state.coinHistories = data
    },
    setGetMissionByIdLoading: (state, data) => {
        state.getMissionByIdLoading = data
    },
    setMissionLayoutType: (state, data) => {
        state.missionLayoutType = data
    },
    setMissionBadge: (state, data) => {
        state.missionBadge = data
    },
    setCancelTokens: (state, data) => {
        const oldData = { ...state.cancelToken }
        state.cancelToken = {
            ...oldData,
            ...data,
        }
    },
}
